



























































import {
    Component,
    Vue,
    Prop,
} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import { Queue } from '@/store/modules/queue/types';
import { Agent, BridgeAgent } from '@/store/modules/agent';
import idealName from '@/utils/ideal-name';

@Component({
    components: {
        Icon,
    },
})
export default class QueueRow extends Vue {
    @Prop(String) readonly queueName!: string;

    @Prop({ type: Array, default: () => [] }) readonly dids!: string[];

    showTooltip = false;

    // Usa getter del store para reactividad
    get queue(): Queue {
        return this.$store.getters.getQueueByName(this.queueName);
    }

    get displayName(): string {
        return this.$store.getters.queueName(this.queueName);
    }

    get activeCalls(): number {
        // Cuenta llamadas activas iterando sobre agentes con queueCalls en esta queue
        const agentsContainer = this.$store.state.agent?.agentsContainer || {};
        let count = 0;
        const normalizedQueueName = idealName(this.queueName);

        Object.values(agentsContainer).forEach((agent: unknown) => {
            const a = agent as Agent;
            if (a.queueCalls && a.queueCalls.size > 0) {
                a.queueCalls.forEach((call: BridgeAgent) => {
                    if (idealName(call.queue) === normalizedQueueName) {
                        count += 1;
                    }
                });
            }
        });

        return count;
    }

    get waitingCalls(): number {
        // Usa getter del store para asegurar reactividad
        return this.$store.getters.queueMembersCount(this.queueName) || 0;
    }

    // eslint-disable-next-line class-methods-use-this
    formatDid(did: string): string {
        if (!did) return '';
        const cleaned = did.replace(/\D/g, '');
        if (cleaned.length === 10) {
            return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
        }
        if (cleaned.length === 11 && cleaned.startsWith('1')) {
            return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
        }
        return did;
    }
}
